<template>
  <transition name="fade">
    <div v-if="visible" class="lbld-ov" role="status" aria-live="polite">
      <div class="box">
        <!-- <div class="row title skeleton"></div> -->

        <div class="cards">
          <div v-for="n in cards" :key="n" class="card">
            <div class="bar skeleton"></div>

            <div class="podium">
              <div class="col">
                <div class="pill skeleton"></div>
                <div class="colBar skeleton h90"></div>
                <div class="badge skeleton"></div>
              </div>
              <div class="col center">
                <div class="pill skeleton wide"></div>
                <div class="colBar skeleton h120"></div>
                <div class="badge skeleton"></div>
              </div>
              <div class="col">
                <div class="pill skeleton"></div>
                <div class="colBar skeleton h100"></div>
                <div class="badge skeleton"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="hint">Loading leaderboard…</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: {
    visible: { type: Boolean, default: true },
    cards: { type: Number, default: 4 }
  }
};
</script>

<style scoped>
.lbld-ov{position:fixed; inset:0; z-index:9999; display:grid; place-items:center;
  background:rgba(40,51,53,.92); color:#fff;}
.box{width:min(1200px,95vw); padding:20px; border-radius:16px;}
.row.title{height:20px; width:220px; margin:0 auto 14px; border-radius:10px;}

.cards{display:grid; gap:16px; grid-template-columns:repeat(auto-fit,minmax(220px,1fr));}
.card{padding:12px; border-radius:14px; background:rgba(255,255,255,.07);}

.bar{height:16px; width:60%; margin:6px auto 12px; border-radius:8px;}

.podium{display:grid; grid-template-columns:1fr 1fr 1fr; align-items:end; gap:8px; min-height:160px;}
.col{display:grid; grid-template-rows:auto 1fr auto; align-items:end; justify-items:center; gap:6px;}
.center{transform:translateY(-6px);}

.pill{height:12px; width:70%; border-radius:999px;}
.pill.wide{width:85%;}
.colBar{width:70%; border-radius:12px;}
.h90{height:90px;} .h100{height:100px;} .h120{height:120px;}
.badge{height:16px; width:50px; border-radius:8px;}

.skeleton{background:rgba(255,255,255,.22); position:relative; overflow:hidden;}
.skeleton::after{content:""; position:absolute; inset:0; transform:translateX(-100%);
  background:linear-gradient(90deg,transparent,rgba(255,255,255,.35),transparent);
  animation:shimmer 1.2s linear infinite;}
@keyframes shimmer{100%{transform:translateX(100%)}}

.fade-enter-active,.fade-leave-active{transition:opacity .2s ease;}
.fade-enter-from,.fade-leave-to{opacity:0;}

@media (prefers-reduced-motion:reduce){.skeleton::after{animation:none}}
.hint{margin-top:10px; font-size:12px; opacity:.8; text-align:center;font-size: 2rem;font-weight: bold;}
</style>
